
import { VastCreativeLinear, VastResponse, VASTTracker } from "vast-client";
import {useMemo} from "react";
import {Source} from "../../state/source";

type VastSource = {
    type: string,
    src: string,
    width: number,
    height: number
}

export type VastType = {
    sources: VastSource[],
    companion?: any
    tracker?: VASTTracker,
    response?: VastResponse
}| "NONE"

export const createSourceObjects = (media_files:any) => {

    var sourcesByFormat: VastSource[] = [];


    for (var a = 0, b = media_files.length; a < b; a++) {
        const media_file = media_files[a];

        // Check if source can be played with this technology
        sourcesByFormat.push({
            type: media_file.mimeType as string,
            src: media_file.fileURL as string,
            width: media_file.width as number,
            height: media_file.height as number
        });
    }
    return sourcesByFormat;
}

export const getSources = (source: Source) : VastType => {
    if (source.type !== "AdvertisementVast") {
        return 'NONE';
    }

    const response = source.content;
    const vast: VastType = { sources: [] }
    let vastTracker:VASTTracker|undefined = undefined;

    for (let adIdx = 0; adIdx < response.ads.length; adIdx++) {
        const ad = response.ads[adIdx];
        vast.companion = undefined;

        for (var creaIdx = 0; creaIdx < ad.creatives.length; creaIdx++) {
            var creative = ad.creatives[creaIdx], foundCreative = false, foundCompanion = false;
            if (creative.type === "linear" && !foundCreative) {
                const linear = creative as VastCreativeLinear;
                if (linear.mediaFiles.length) {
                    vast.sources = createSourceObjects(linear.mediaFiles);
                    if (!vast.sources.length)
                        return "NONE";
                    vastTracker = new VASTTracker(null, ad, linear);
                    vastTracker.on('clickthrough', (url:any) => {
                        window.open(url, '_blank');
                    });
                    foundCreative = true;
                    vast.companion = creative;
                }
            } else if (creative.type === "companion" && !foundCompanion) {
                vast.companion = creative;
                foundCompanion = true;
            }
        }

        if (vastTracker) {
            return {...vast, tracker: vastTracker, response: response};
        } else {
            return 'NONE';
        }
    }

    return "NONE";
}

export const useSources = (source: Source)=> useMemo(() => getSources(source), [source])
